// React Dependencies
import React from 'react';

// External Dependencies
import { Button } from '@material-ui/core';

// Internal Dependencies
import SortableCard from '../../../pages/categoryPinnedPost/sortableCard';

export default function PostsMainView({ title, sortableCardRef, onEvent, onClickAdd, onDelete, onUpdatePosType, cards, isSortable, cardype }) {
  return (
    <div className="col-md-10 card-left">
      <div className="d-flex flex" style={{ backgroundColor: '#fff' }}>
        <h4>{title}</h4>
        <Button
          onClick={onClickAdd}
          className="ml-4"
          style={{ position: 'relative', top: -7 }}
          color="primary"
          variant="contained"
          size="large"
        >
          Add Post
        </Button>
      </div>
      <SortableCard
        ref={sortableCardRef}
        onEvent={onEvent}
        onDelete={(postId) => onDelete(postId)}
        onUpdatePosType={(data) => onUpdatePosType(data)}
        cards={cards}
        isSortable={isSortable}
        cardype={cardype}
      />
    </div>
  );
}
